import React, { useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const formRef = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData(formRef.current);
    const payload = {
      name: fd.get("name"),
      email: fd.get("email"),
      subject: fd.get("subject"),
      message: fd.get("message"),
    };

    try {
      const apiUrl = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api/contact` : "/api/contact";
      const res = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (res.ok) {
        toast.success("Message sent");
        formRef.current.reset();
      } else {
        const err = await res.json().catch(() => null);
        toast.error(err?.error || "Failed to send message");
      }
    } catch (err) {
      toast.error("Network error");
    }
  };

  return (
    <section className="py-0 mb-20" data-scroll-reveal>
      <div className="flex flex-wrap w-full">
        {/* Glass container for contact form */}
        <div className="w-full relative rounded-2xl overflow-hidden">
          {/* Glass background */}
          <div className="absolute inset-0 bg-white/70 backdrop-blur-md" />
          
          {/* Gradient border */}
          <div className="absolute inset-0 rounded-2xl p-[2px] bg-gradient-to-br from-green-400/30 to-blue-400/20" />
          
          {/* Content */}
          <form ref={formRef} onSubmit={handleSubmit} className="relative z-10 p-8 md:p-10 rounded-2xl border border-white/40">
            <h3 className="text-2xl md:text-3xl bg-gradient-to-r from-gray-900 to-green-600 bg-clip-text text-transparent font-bold mb-6">
              Get in Touch
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  className="w-full border border-green-200/50 rounded-lg py-3 px-4 text-sm bg-white/60 backdrop-blur-sm placeholder-gray-500 focus:outline-none focus:border-green-500 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="your@email.com"
                  className="w-full border border-green-200/50 rounded-lg py-3 px-4 text-sm bg-white/60 backdrop-blur-sm placeholder-gray-500 focus:outline-none focus:border-green-500 transition-colors"
                />
              </div>
            </div>
            
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">Subject</label>
              <input
                type="text"
                name="subject"
                required
                placeholder="What is this about?"
                className="w-full border border-green-200/50 rounded-lg py-3 px-4 text-sm bg-white/60 backdrop-blur-sm placeholder-gray-500 focus:outline-none focus:border-green-500 transition-colors"
              />
            </div>
            
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
              <textarea
                name="message"
                required
                placeholder="Your message here..."
                rows="5"
                className="w-full border border-green-200/50 rounded-lg py-3 px-4 text-sm bg-white/60 backdrop-blur-sm placeholder-gray-500 focus:outline-none focus:border-green-500 transition-colors resize-none"
              />
            </div>
            
            <div className="flex justify-end">
              <input
                type="submit"
                value="Send Message"
                className="px-6 py-3 font-semibold text-white rounded-lg cursor-pointer bg-gradient-to-r from-green-500 to-emerald-500 hover:shadow-lg hover:shadow-green-500/40 hover:-translate-y-1 transition-all"
              />
            </div>
            <ToastContainer />
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
